import {
    FETCH_SCAN_TYPES_START,
    FETCH_SCAN_TYPES_SUCCESS,
    FETCH_SCAN_TYPES_ERROR,
    ADD_UPDATE_SCAN_TYPE_START,
    ADD_UPDATE_SCAN_TYPE_SUCCESS,
    ADD_UPDATE_SCAN_TYPE_ERROR,
    SET_SCAN_TYPES_PAGINATION
} from '../../actions/common/scan-types-action';

const INIT_STATE = {
    error: "",
    submitting: false,
    loading: false,
    message: '',
    scanTypes: [],
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalItems: 0,
    }
};

const scanTypesReducer = (state = INIT_STATE, action) => {
    let index;
    let newScanTypes;
    switch (action.type) {
        case FETCH_SCAN_TYPES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_SCAN_TYPES_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, scanTypes: action.scanTypes };
        }
        case FETCH_SCAN_TYPES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case ADD_UPDATE_SCAN_TYPE_START: {
            return { ...state, submitting: true };
        }
        case ADD_UPDATE_SCAN_TYPE_SUCCESS: {
            newScanTypes = [...state.scanTypes];
            index = newScanTypes.findIndex(scanType => scanType.scanTypeId === action.scanType.scanTypeId);
            if (index > -1) {
                newScanTypes.splice(index, 1, action.scanType);
            } else {
                newScanTypes.push({ ...action.scanType });
            }
            return { ...state, submitting: false, scanTypes: [...newScanTypes] };
        }
        case ADD_UPDATE_SCAN_TYPE_ERROR: {
            return { ...state, submitting: false };
        }
        case SET_SCAN_TYPES_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        default:
            return state;
    }
}

export default scanTypesReducer;
